export const questionCategoriesOptions = [
    {value:"0", label: "Default"},
    {value:"2", label: "Demographics"},
    {value:"5", label: "Honeypot"}
  ];